import { createApi } from "@reduxjs/toolkit/query/react";
import { Paragraph } from "@src/pages/super-admin/paragraphs/Paragraphs.types";
import { APIResponse, PaginationType } from "@src/types/CommonTypes";
import { baseQueryWithReauth } from "@src/utils/baseQuery";

interface GetAllParagraphsResponse extends APIResponse {
  response: { content: Paragraph[] } & PaginationType;
}

interface AddParagraphResponse extends APIResponse {
  response: Paragraph;
}

interface GetParagraphsDropdownResponse extends APIResponse {
  response: Paragraph[];
}

export const ParagraphApiSlice = createApi({
  reducerPath: "paragraphApiSlice",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllParagraphs: builder.query<
      GetAllParagraphsResponse,
      { pageNo: number; pageSize: number }
    >({
      query: ({ pageNo, pageSize }) => ({
        url: `paragraph/get-all?pageNo=${pageNo}&pageSize=${pageSize}`,
        method: "GET",
      }),
    }),
    getParagraphById: builder.query<AddParagraphResponse, { id: string }>({
      query: ({ id }) => ({
        url: `paragraph?paragraphId=${id}`,
        method: "GET",
      }),
    }),
    getParagraphsDropdown: builder.query<GetParagraphsDropdownResponse, void>({
      query: () => ({
        url: `paragraph/get-dropDown`,
        method: "GET",
      }),
    }),
    addParagraph: builder.mutation<AddParagraphResponse, { payload: FormData }>({
      query: ({ payload }) => ({
        url: `paragraph`,
        method: "POST",
        body: payload,
      }),
    }),
    updateParagraph: builder.mutation<
      AddParagraphResponse,
      { payload: FormData; id: string }
    >({
      query: ({ payload, id }) => ({
        url: `paragraph?paragraphId=${id}`,
        method: "PUT",
        body: payload,
      }),
    }),
    deleteParagraph: builder.mutation<APIResponse, { id: string }>({
      query: ({ id }) => ({
        url: `paragraph?paragraphId=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetAllParagraphsQuery,
  useLazyGetParagraphByIdQuery,
  useLazyGetParagraphsDropdownQuery,
  useGetParagraphsDropdownQuery,
  useAddParagraphMutation,
  useUpdateParagraphMutation,
  useDeleteParagraphMutation,
} = ParagraphApiSlice;
